import { ref, uploadString, getDownloadURL } from 'firebase/storage';
import { storage } from '../lib/firebase';

/**
 * Upload a brand logo to Firebase Storage
 * @param {string} imageDataUrl - Base64 data URL of the image
 * @param {string} userId - The user's ID
 * @param {string} brandId - The brand's ID (use 'new' for new brands)
 * @returns {Promise<string>} - The download URL of the uploaded image
 */
export async function uploadBrandLogo(imageDataUrl, userId, brandId = 'new') {
    const mimeMatch = imageDataUrl.match(/data:image\/([^;]+);/);
    const extension = mimeMatch ? mimeMatch[1].replace('jpeg', 'jpg') : 'png';

    const imageId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    const storageRef = ref(storage, `brands/${userId}/${brandId}/logo-${imageId}.${extension}`);

    await uploadString(storageRef, imageDataUrl, 'data_url');
    const downloadURL = await getDownloadURL(storageRef);

    return downloadURL;
}
